import LayoutDefault from "./Default"

const Layout = {
    Default: LayoutDefault,
}

export default Layout